import whenDomReady from 'when-dom-ready';
import App from './App.svelte';

const init = () =>
    whenDomReady().then(() => {
        const app = new App({
            target: document.querySelector('.faq-container'),
            intro: true,
            props: {},
        });

        return app;
    });

export default init();
